import React, { useState } from 'react';
import styles from './LeaveRejectModal.module.scss';

type Props = {
  onClose: () => void,
  onConfirm: (reason: string) => void,
};

const LeaveRejectModal = ({ onClose, onConfirm }: Props) => {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();
  const canSubmit = trimmed.length > 0;

  const handleSubmit = () => {
    if (!canSubmit) return;
    onConfirm(trimmed);
  };

  return (
    <div className={styles.container}>
      <h4>Refuser la demande</h4>
      <div className={styles.field}>
        <label htmlFor="leave-reject-reason">Motif du refus</label>
        <textarea
          id="leave-reject-reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Indiquez la raison du refus…"
        />
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.cancel} onClick={onClose}>
          Annuler
        </button>
        <button type="button" disabled={!canSubmit} onClick={handleSubmit}>
          Refuser
        </button>
      </div>
    </div>
  );
};

export default LeaveRejectModal;
